import { Periodo } from '../models/periodo';

export const ID_PERIODO_ULTIMOS_SEIS_MESES = 1;
export const ID_PERIODO_ANO_ANTERIOR = 2;
export const PERIODOS: Periodo[] = [
  { id: ID_PERIODO_ULTIMOS_SEIS_MESES, nombre: 'Últimos 6 meses' },
  { id: ID_PERIODO_ANO_ANTERIOR, nombre: 'Año anterior' },
];
